import { MoreHoriz } from "@mui/icons-material";
import { IconButton, Menu, MenuItem, SxProps } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { HubChangeNameDialog } from "./HubChangeNameDialog/HubChangeNameDialog";
import { HubRestartDialog } from "./HubRestartDialog";

interface HubActionsProps {
  hubId: string;
  hubName: string;
  disabled?: boolean;
  sx?: SxProps;
}

export function HubActions(props: HubActionsProps) {
  const { hubId, hubName, disabled, sx } = props;
  const [selectedHubId, setSelectedHubId] = useState<string | null>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setSelectedHubId(hubId);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const [openHubChangeNameDialog, setOpenHubChangeNameDialog] = useState<boolean>(false);
  const [openHubRestartDialog, setOpenHubRestartDialog] = useState<boolean>(false);

  const handleOpenHubChangeNameDialog = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setOpenHubChangeNameDialog(true);
    handleClose(event);
  };

  const handleCloseHubChangeNameDialog = () => {
    setOpenHubChangeNameDialog(false);
    setSelectedHubId(null);
  };

  const handleOpenHubRestartDialog = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setOpenHubRestartDialog(true);
    handleClose(event);
  };

  const handleCloseHubRestartDialog = () => {
    setOpenHubRestartDialog(false);
    setSelectedHubId(null);
  };

  const handleNavigateHubStatusPage = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    navigate(`/reef/hubs/${hubId}/status`);
    handleClose(event);
  };

  return (
    <>
      <IconButton
        data-testid="hub-actions"
        aria-label="more"
        id="hub-actions-button"
        aria-controls={open ? "hub-actions-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled}
        sx={[{ padding: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}
      >
        <MoreHoriz />
      </IconButton>
      <Menu
        id="hub-actions-menu"
        data-testid="hub-actions-menu"
        MenuListProps={{
          "aria-labelledby": "hub-actions-button",
        }}
        anchorEl={anchorEl}
        open={open && hubId === selectedHubId}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleOpenHubChangeNameDialog}>Edit Vision Core name</MenuItem>
        <MenuItem onClick={handleNavigateHubStatusPage}>View device system status</MenuItem>
        <MenuItem onClick={handleOpenHubRestartDialog}>Restart Vision Core</MenuItem>
      </Menu>
      {openHubChangeNameDialog && hubId === selectedHubId && (
        <HubChangeNameDialog
          isDialogOpen={openHubChangeNameDialog}
          onCloseDialog={handleCloseHubChangeNameDialog}
          hubId={hubId}
          hubCurrentName={hubName}
        />
      )}
      {openHubRestartDialog && hubId === selectedHubId && (
        <HubRestartDialog
          isDialogOpen={openHubRestartDialog}
          onCloseDialog={handleCloseHubRestartDialog}
          hubId={hubId}
          hubName={hubName}
        />
      )}
    </>
  );
}
